export default __webpack_public_path__ + "static/media/Roby.a8d82754.JPG";